<template>
  <div class="vx">
    <div v-if="activeTab === 0">
      <div class="header">
        <div class="flex item-center picker-depart">
          <div
            class="store-picker flex"
            @click="toMini('/pages/selectMechanism/selectMechanism')"
          >
            <div class="flex item-center store">
              <span
                class="hmicon icon-shangcheng"
                style="font-size: 20px"
              ></span>
              <div class="flex flex-center item-center store-name">
                <div class="uni-input">
                  {{ departName || currentDepart.departName || "选择机构" }}
                </div>
              </div>
              <span class="hmicon icon-xiala1"></span>
            </div>
          </div>
        </div>

        <el-scrollbar
          style="width: calc(100vw-100px)"
          class="pagescroll search-wrapper flex flex-wrap"
          v-if="reportLabel.length"
        >
          <div
            class="label"
            :class="{ active: activeLabel === i }"
            v-for="(v, i) in reportLabel"
            :key="i"
            @click="switchLabel(i, v)"
          >
            {{ v.reportName }}
          </div>
        </el-scrollbar>
      </div>
      <div class="preview-container">
        <el-scrollbar>
          <div class="preview-body preview-list-group">
            <!-- <keep-alive> -->
            <div v-for="(v, i) in previewComponents" :key="i" id="vcharts">
              <component
                :is="v.component"
                ref="singleComponent"
                v-bind="v.prop"
              ></component>

              <!-- <div  v-if="v.component === 'table-chart'">
                <table-chart v-bind="v.prop">
                </table-chart>
              </div>
              <ve-pie
                :data="v.chartData"
                v-if="v.component === 'pie-chart'"
              ></ve-pie>
              <ve-line
                :data="v.chartData"
                v-if="v.component === 'line-chart'"
              ></ve-line>
              <ve-histogram
                :data="v.chartData"
                v-if="v.component === 'bar-chart'"
              ></ve-histogram> -->
              <!-- <el-table
                v-if="v.component === 'table-chart'"
                :data="v.chartData"
                :default-sort="{ prop: 'num', order: 'descending' }"
                ref="hmtable"
              >
                <el-table-column
                  v-show="v.prop.header.length"
                  v-for="(col, index) in v.prop.header"
                  :key="index"
                  :prop="col.columnName"
                  :label="col.labelName"
                  :type="col.type"
                  :header-align="col.headerAlign"
                  :column-key="index.toString()"
                  sortable
                >
                </el-table-column>
              </el-table> -->
            </div>
            <!-- </keep-alive> -->
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div v-if="activeTab === 1" :class="drawer ? 'report-fixed' : ''">
      <div class="header">
        <div class="flex item-center picker-depart">
          <div
            class="store-picker flex"
            @click="toUrl('/pages/selectMechanism/selectMechanism')"
          >
            <div class="flex item-center store">
              <span
                class="hmicon icon-shangcheng"
                style="font-size: 20px"
              ></span>
              <div class="flex flex-center item-center store-name">
                <div class="uni-input">
                  {{ departName || currentDepart.departName || "选择机构" }}
                </div>
              </div>
              <span class="hmicon icon-xiala1"></span>
            </div>
          </div>
        </div>

        <!-- <div class="p10 flex flex-between item-center tip" v-if="showTip">
          <div style="fontsize: 13px">
            您可以通过添加按钮查看更多您要显示的报表布局
          </div>
          <span
            @click="close"
            class="flex item-center hmicon icon-guanbi1"
          ></span>
        </div> -->
      </div>
      <div class="preview-containers">
        <div class="preview-wrapper">
          <div class="preview-body">
            <div class="report-list" v-for="(v, i) in allLabel" :key="i">
              <div class="flex flex-between item-center report-category bb1">
                <div class="report-title" @click="toggleDetails(v)">
                  {{ v.title }}
                  <span
                    :class="{ rotate: v.showReport }"
                    class="hmicon icon-arrow-down"
                  ></span>
                </div>
                <div
                  class="add-wrapper small"
                  style="background: #005ceb"
                  @click="add(v, i)"
                >
                  <span class="hmicon icon-hao pointer"></span>
                </div>
              </div>
              <div
                class="report-name bb1 flex item-center"
                v-for="(o, k) in v.reportArray"
                :key="k"
                v-if="v.reportArray && v.reportArray.length && v.showReport"
              >
                <div style="width:25px" class="mr10">
                  <img
                    style="width:100%"
                    src="https://imgcdn.hemiao100.com/ThemePictures/daoogu.png"
                    alt=""
                  />
                </div>
                <!-- <span
                  class="hmicon icon-daogoubaobiao"

                ></span> -->
                {{ o.reportName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="isIphone" :class="isIpx?'tabbar-container-ipx':'tabbar-container'">

        <div class="tabbar flex item-center flex-around">
          <div
            :class="{ active: activeTab == i }"
            @click="toUrl(i, v)"
            class="tabbar-item flex-1"
            v-for="(v, i) in reportsTabs"
            :key="i"
          >
            <div class="flex flex-center">
              <span
                class="hmicon"
                :class="v.icon"
                style="marginright: 12px"
              ></span>
              <div class="text-center">{{ v.title }}</div>
            </div>
          </div>
        </div>

    </div> -->
    <div class="tabbar-containers">
      <div class="tabbar flex item-center flex-around">
        <div
          :class="{ active: activeTab == i }"
          @click="toUrl(i, v)"
          class="tabbar-item flex-1"
          v-for="(v, i) in reportsTabs"
          :key="i"
        >
          <div class="flex flex-center">
            <!-- <span
              class="hmicon"
              :class="v.icon"
              style="marginright: 12px"
            ></span> -->
            <div class="text-center">{{ v.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div  :class="isIphone?'tabbar-container':'tabbar-containers'">
      <div class="tabbar flex item-center flex-around">
        <div
          :class="{ active: activeTab == i }"
          @click="toUrl(i, v)"
          class="tabbar-item flex-1"
          v-for="(v, i) in reportsTabs"
          :key="i"
        >
          <div class="flex flex-center">
            <span
              class="hmicon"
              :class="v.icon"
              style="marginright: 12px"
            ></span>
            <div class="text-center">{{ v.title }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <el-button @click="drawer = true" type="primary" style="margin-left: 16px">
      点我打开
    </el-button> -->

    <!-- <div class="flex flex-column mb-count">
      <div class="change-wrapper" style="order: 1">
        <div class="flex flex-between item-center">
          <div class="headline">
            <span class="title">月度指标达成</span>
            <span
              @click="onTip('month')"
              class="iconfont iconalert2 ml10"
            ></span>
          </div>
          <div style="color: #999">(截止昨日数据，每日凌晨更新)</div>
        </div>
        <div>
          <div class="reports-header flex mt10">
            <div class="flex-1">指标类型</div>
            <div class="flex-2">达成值</div>
            <div class="flex-1">目标</div>
          </div>
          <div
            class="reports-body flex item-center"
            v-for="(v, i) in targetList"
            :key="i"
            :style="{ color: v.color }"
          >
            <div class="flex-1 title" style="fontsize: 14px">
              {{ v.title }}
            </div>
            <div class="flex-2 flex">
              <span>
                {{ v.actualValue }}
              </span>
              <div class="flex-1">
                <el-progress
                  :text-inside="false"
                  :percentage="v.percentage"
                ></el-progress>
              </div>
            </div>

            <div class="flex-1">
              {{ v.targetValue }}
            </div>
          </div>
        </div>
      </div>

      <div class="change-wrapper" style="order: 2">
        <div class="flex flex-between item-center" style="marginbottom: 5px">
          <div class="headline">
            <span class="title">经营数据</span>
            <span
              @click="onTip('sale')"
              style="marginleft: 5px"
              class="iconfont iconalert2"
            ></span>
          </div>
          <div class="tabs flex">
            <div
              v-for="(v, i) in tabs"
              class="tab"
              :class="{ active: activeTab === i }"
              :key="i"
              @click="switchTab(i, v)"
            >
              {{ v.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="change-wrapper" style="order: 3">
        <div class="flex flex-between item-center" style="marginbottom: 5px">
          <div class="in-headline">
            <span class="title">微店经营</span>
          </div>
          <div class="more">
            <span>查看更多</span>
            <span class="hmicon icon-youjiantou"></span>
          </div>
        </div>
        <div class="reports-content last-border flex flex-around item-center">
          <div>
            <div class="titles">微店销售额(元)</div>
            <div class="text text-center">
              {{ shopInfo.shopSalesAmount || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">微店订单数(单)</div>
            <div class="text text-center">
              {{ shopInfo.shopSalesOrderNum || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">微店客单价(元/单)</div>
            <div class="text text-center">{{ shopInfo.unit || 0 }}</div>
          </div>
        </div>
        <div class="reports-content last-border flex flex-around item-center">
          <div>
            <div class="titles">分销销售额(元)</div>
            <div class="text text-center">
              {{ shareInfo.shopSalesAmount || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">分销订单数(单)</div>
            <div class="text text-center">
              {{ shareInfo.shopSalesOrderNum || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">分销客单价(元/单)</div>
            <div class="text text-center">{{ shareInfo.unit || 0 }}</div>
          </div>
        </div>

        <div class="reports-content flex flex-around item-center">
          <div>
            <div class="titles">已退款金额(元)</div>
            <div class="text text-center">
              {{ expressInfo.shopSalesAmount || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">待发货订单(单)</div>
            <div class="text text-center">
              {{ expressInfo.waitProcessNum || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">待处理售后( 订单 )</div>
            <div class="text text-center">
              {{ expressInfo.waitExpressNum || 0 }}
            </div>
          </div>
        </div>
      </div>
      <div class="change-wrapper" style="order: 4">
        <div class="flex flex-between item-center" style="marginbottom: 5px">
          <div class="off-headline">线下经营</div>
          <div class="more">
            <span>查看更多</span>
            <span class="hmicon icon-youjiantou"></span>
          </div>
        </div>
        <div class="reports-content flex flex-around item-center">
          <div>
            <div class="titles">线下销售额(元)</div>
            <div class="text text-center">
              {{ OfflineInfo.shopSalesAmount || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">线下订单数(单)</div>
            <div class="text text-center">
              {{ OfflineInfo.shopSalesOrderNum || 0 }}
            </div>
          </div>
          <div class="line"></div>
          <div>
            <div class="titles">线下客单价(元/单)</div>
            <div class="text text-center">{{ OfflineInfo.unit || 0 }}</div>
          </div>
        </div>
      </div>
      <div class="change-wrapper" style="order: 5">
        <div class="headline">
          <span class="title">更多报表</span>
        </div>
        <div class="menu flex  flex-around">
          <div
          
            v-for="(v, i) in themeList"
            :key="i"
            @click="toUrl(v.url)"
          >
            <div class="text">
              <img class="img" style="width: 50px" :src="v.img" alt="xx" />

              <div class="text">{{ v.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 
    <div style="width: calc(100vw-100px)">
      <el-scrollbar style="width: calc(100vw-100px)" class="pagescroll">
        <div style="width: 600px; border: 1px solid #ddd">
          <el-table
            stripe
            ref="table"
            :data="list"
            style="width: 100%"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="所属机构"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="目标销售额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="销售额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="销售额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="ruleName"
              label="销售额"
            ></el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
    </div> -->

    <div class="back-home">
      <div
        class="home-button flex flex-column item-center flex-center"
        @click="goHome"
      >
        <text class="iconfont iconshouye" style="font-size: 37rpx"></text>
        返回首页
      </div>
    </div>
    <el-drawer
      title="导购报表"
      :visible.sync="drawer"
      direction="btt"
      size="80%"
    >
      <div slot="title" class="flex flex-center drawer-title p10">
        <!-- 导购报表（报表分类） -->
        {{ row.title }}
      </div>
      <!-- <div class="p10 flex flex-between tip" v-if="showTip">
        <div>
          您可以通过勾选以确认要显示的报表内容，也可以通过
          拖拽改变上下顺序保存您喜欢的报表布局
        </div>
        <span
          @click="close"
          class="flex item-center hmicon icon-guanbi1"
        ></span>
      </div> -->
      <div class="phone">
        <el-scrollbar
          wrap-style="height: 500px;"
          class="page-component__scroll"
        >
          <el-checkbox-group
            class="report-mb"
            v-model="checkList"
            @change="checked"
          >
            <!-- <draggable :list="list"> -->
            <div
              class="flex table-row item-center"
              v-for="(item, index) in list"
              :key="index"
            >
              <el-checkbox
                size="small"
                :label="item"
                class="flex-1 flex item-center"
              >
                <div class="report-lable flex item-center flex-between">
                  <!-- <div class="report-icon flex flex-center item-center"> -->
                  <div style="color: #000" class="flex item-center">
                    <div style="width:25px" class="mr10">
                      <img
                        style="width:100%"
                        src="https://imgcdn.hemiao100.com/ThemePictures/daoogu.png"
                        alt=""
                      />
                    </div>
                    {{ item.reportName }}
                  </div>
                  <div class="mr20 icon" style="color: #666">
                    <button
                      @click="upGo(index)"
                      class="pointer no-bg"
                      :disabled="index === 0"
                    >
                      <span class="hmicon icon-shangyi1"></span>
                    </button>
                    <button
                      @click="downGo(index)"
                      class="pointer no-bg"
                      :disabled="index === list.length - 1"
                    >
                      <span class="hmicon icon-xiayi1"></span>
                    </button>
                    <!-- <span class="hmicon icon-shangyi mr10"   v-if="index !== 0"></span> -->
                    <!-- <span class="hmicon icon-xiayi" v-if="index !== list.length - 1"></span> -->
                  </div>

                  <!-- </div> -->
                </div>
              </el-checkbox>
            </div>
            <!-- </draggable> -->
          </el-checkbox-group>
        </el-scrollbar>
      </div>

      <div
        :class="isIphone ? 'report-footer' : 'report-footers'"
        class="flex item-center flex-center"
        style="width: 100%"
      >
        <el-button
          type="primary"
          size="small"
          @click="save"
          class="report-save-btn"
          >确 定</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import barChart from "@/components/charts/barChart";
import lineChart from "@/components/charts/lineChart";
import pieChart from "@/components/charts/pieChart";
import TableChart from "@/components/charts/tableChart";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import Vue from "vue";

// import VePie from "v-charts/lib/pie.common";
// import VeHistogram from "v-charts/lib/histogram.common";
// import VeLine from "v-charts/lib/line.common";
// import TableChart from "@/components/charts/tableChart";
import moment from "moment";
import { getSubtract, arrayUnique2, unique } from "@/utils/utils";
import { reportFormComponents, predefine } from "@/utils/tempData";

var tdata = [];
for (let i = 0; i < 20; i++) {
  tdata.push({
    label: "第" + i + "行",
    value: i
  });
}
export default {
  components: {
    // VePie,
    // VeHistogram,
    // VeLine,
    // TableChart
    barChart,
    lineChart,
    pieChart,
    TableChart,
    imageAdSelection
  },
  data() {
    return {
      integerTableHeader: [],
      reportFormComponents,
      tableConditions: [],
      tableHeader: [],
      imgAdSelectionUpLoadType: "leftImgList",
      groupGoodsVisible: false,
      avatarUrl:
        "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/timg.jpg",
      isRadio: false,
      goodsType: "",
      tabBarList: {
        plusBg:
          "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/65a9b379fb66ac3c7b1d6f6e06bb02f.png",
        showAmountSaved: false,
        showTotalSaved: false,
        showVipCard: true,
        showPlusCouponCount: true,
        showCoupon: true
      },
      selectedThead: "",
      selectedConditions: "",
      pageType: "",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      currentIndex: "",
      predefine,
      showPageSetting: true,
      dialogVisible: false,
      show: false,
      title: "",
      hotWord: "",
      activePreviewIndex: "",
      tableList: [],
      col: [],
      coypColList: [],
      searchList: [],
      tableGroup: [],
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      allComponents: [],
      previewComponents: [],
      currentLinkIndex: "",
      currentLinkPropName: "",
      selectCouponVisible: false,
      dropCol: [],

      themeList: [
        {
          img: "https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%84%20105.png",
          name: "微店实时数据",
          url: "/pages/weChatTimeReports/weChatTimeReports"
        },

        {
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/%E7%BB%84%20105(1).png",
          name: "线下实时报表",
          url: "/pages/realTimeReports/realTimeReports"
        }
      ],
      shareInfo: {},
      expressInfo: {},
      OfflineInfo: {},
      shopInfo: {},
      tabs: [
        {
          name: "昨天",
          value: "yesterday"
        },
        {
          name: "今天",
          value: "today"
        }
      ],
      targetList: [
        {
          title: "测试",
          actualValue: 40,
          percentage: 20,
          targetValue: 200
        },
        {
          title: "测试",
          actualValue: 40,
          percentage: 20,
          targetValue: 200
        },
        {
          title: "测试",
          actualValue: 40,
          percentage: 20,
          targetValue: 200
        }
      ],
      checkList: [],
      showTip: true,
      drawer: false,
      activeTab: 0,
      reportsTabs: [
        {
          title: "我的报表",
          url: "/pages/reports/reports",
          icon: "icon-tubiaozhu"
        },
        {
          title: "报表管理",
          url: "/pages/reportManagement/reportManagement",
          icon: "icon-baobiao"
        }
      ],
      currentDepart: {},
      departName: "",
      activeLabel: 0,
      reportLabel: [
        {
          name: "昨天2",
          value: "yesterday"
        },
        {
          name: "今天1",
          value: "today"
        },
        {
          name: "今天2",
          value: "today"
        },
        {
          name: "今天3",
          value: "today"
        },
        {
          name: "今天4",
          value: "today"
        },
        {
          name: "今天5",
          value: "today"
        },
        {
          name: "今天",
          value: "today"
        },
        {
          name: "今天",
          value: "today"
        },
        {
          name: "今天",
          value: "today"
        },
        {
          name: "今天",
          value: "today"
        },
        {
          name: "今天",
          value: "today"
        },
        {
          name: "今天333333",
          value: "today"
        }
      ],
      list: [
        {
          title: "导购销售提成报表1"
        },
        {
          title: "导购销售提成报表2"
        },
        {
          title: "导购销售提成报表3"
        },
        {
          title: "导购销售提成报表4"
        },
        {
          title: "导购销售提成报表5"
        },
        {
          title: "导购销售提成报表6"
        },
        {
          title: "导购销售提成报表7"
        },
        {
          title: "导购销售提成报表8"
        },
        {
          title: "导购销售提成报表9"
        },
        {
          title: "导购销售提成报表10"
        }
      ],
      pickerVisible: false,
      pickData: [
        [
          {
            label: "第" + "1" + "行",
            value: 1
          },
          {
            label: "第" + "2" + "行",
            value: 2
          }
        ]
      ],
      result: "",
      type: "yesterday",
      chartData: {
        columns: ["name", "totalPrice", "targetValue"],
        rows: [
          { name: "张三", totalPrice: 1393, targetValue: 1093, 下单率: 0.32 },
          { name: "张三", totalPrice: 3530, targetValue: 3230, 下单率: 0.26 },
          { name: "张三", totalPrice: 2923, targetValue: 2623, 下单率: 0.76 },
          { name: "张三", totalPrice: 1723, targetValue: 1423, 下单率: 0.49 },
          { name: "张三", totalPrice: 3792, targetValue: 3492, 下单率: 0.323 },
          { name: "张三", totalPrice: 4593, targetValue: 4293, 下单率: 0.78 },
          { name: "张三", totalPrice: 1393, targetValue: 1093, 下单率: 0.32 },
          { name: "张三", totalPrice: 3530, targetValue: 3230, 下单率: 0.26 },
          { name: "张三", totalPrice: 2923, targetValue: 2623, 下单率: 0.76 },
          { name: "张三", totalPrice: 1723, targetValue: 1423, 下单率: 0.49 },
          { name: "张三", totalPrice: 3792, targetValue: 3492, 下单率: 0.323 },
          { name: "张三", totalPrice: 4593, targetValue: 4293, 下单率: 0.78 }
        ]
      },
      chartSettings: {
        labelMap: {
          totalPrice: "销售额",
          targetValue: "目标销售额"
        },
        xAxisType: ["KMB", "KMB"],
        xAxisName: ["销售额", "目标销售额"]
      },
      id: "79d3ddcc8db5f1a7a59ee21079fe7c00",
      employeeId: this.$route.query.employeeId,
      sysAllDict: {},
      reportList: [
        {
          category: "导购报表（报表分类）",
          showReport: true,
          reportArray: [
            {
              rname: "导购销售提成报表"
            },
            {
              rname: "导购销售报表"
            }
          ]
        },
        {
          category: "门店报表",
          showReport: true,
          reportArray: [
            {
              rname: "门店类型分类报表"
            },
            {
              rname: "门店会员构成分析"
            },
            {
              rname: "门店新客分析"
            }
          ]
        },
        {
          category: "商品报表",
          showReport: true,
          reportArray: [
            {
              rname: "品类销售分析"
            },
            {
              rname: "品牌销售分析"
            }
          ]
        }
      ],
      row: {},
      options: [],
      reportHome: {},
      allReport: [],
      queryAllrep: [],
      isIphone: false,
      allLabel: [],
      isIpx: false,
      keep: []
    };
  },
  computed: {},
  watch: {},
  created() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
    document.body.appendChild(script);
    this.appDown();
  },
  mounted() {
    this.remConfig();

    this.getSysAllDictItems();
    this.keep.push({
      reportName: "我的收藏",
      previewComponents: []
    });
    this.isIpx = this.isIphonex();
    Vue.prototype.$employeeId = this.employeeId;
  },
  methods: {
    appDown() {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isiOS) {
        this.isIphone = true;
      } else if (isAndroid) {
        this.isIphone = false;
      }
    },
    isIphonex() {
      if (typeof window !== "undefined" && window) {
        return (
          /iphone/gi.test(window.navigator.userAgent) &&
          window.screen.height >= 812
        );
      }
      return false;
    },
    isMiniProgram() {
      var ua = navigator.userAgent.toLowerCase();
      var envType = "#";
      const { wx } = window;
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            // 小程序环境下逻辑
            envType = true;
          } else {
            //非小程序环境下逻辑
            envType = false;
          }
        });
      } else {
        //非微信环境逻辑
        envType = false;
      }
      return envType;
    },

    goHome() {
      const { wx } = window;
      wx.miniProgram.switchTab({
        url: "/pages/home/home"
      });
    },
    toMini(url) {
      this.navigateTo(url);
    },
    gomini() {
      this.navigateTo("/pages/home/home");
    },
    navigateTo(url) {
      const { wx } = window;
      wx.miniProgram.navigateTo({
        url: url
      });
    },
    async getTreeStruct() {
      const { result } = await this.$store.dispatch("getTreeStruct", {
        pcode: "B03"
      });
      this.options = result;
      this.options.forEach(v => {
        v.showReport = true;
        v.reportArray = [];
      });

      this.queryEmployeePageListByEmployeeId();
    },
    upGo(index) {
      if (index != 0) {
        this.list[index] = this.list.splice(index - 1, 1, this.list[index])[0];
      } else {
        this.list.push(this.list.shift());
      }
    },
    downGo(index) {
      if (index != this.list.length - 1) {
        this.list[index] = this.list.splice(index + 1, 1, this.list[index])[0];
      } else {
        this.list.unshift(this.list.splice(index, 1)[0]);
      }
    },
    add(item) {
      let v = this.allReport.filter(o => o.key === item.key)[0];
      this.row = v;
      this.list = v.reportArray;
      this.funcIdList = [];
      this.reportLabel.forEach(v => {
        if (
          this.list.findIndex(o => o.configId === v.configId) < 0 &&
          v.reportName !== "我的收藏"
        ) {
          this.funcIdList.push(v);
        }
      });
      this.checkList = item.reportArray;
      this.drawer = true;
    },
    toggleDetails(item) {
      item.showReport = !item.showReport;
      this.$forceUpdate();
    },
    async querySaveByEmployeeId() {
      const { result } = await this.$store.dispatch("querySaveByEmployeeId", {
        pageSize: 9999,
        pageNo: 1,
        accountId: this.employeeId,
        layoutType: "miniprogram",
        funcType: "visualView",
        moduleType: "ssr"
      });
      const { records } = result;
      if (records.length) {
        let list = [];
        list = JSON.parse(records[0].funcId);
        // console.log("已收藏报表id", list);
        let reportList = [];
        list.forEach(v => {
          this.queryAllrep.forEach(k => {
            if (k.configId === v) {
              reportList.push(k);
            }
          });
        });
        // console.log("通过id找到所属的报表", reportList);
        this.allLabel.forEach(v => {
          reportList.forEach(k => {
            if (v.key === k.sysCategoryId) {
              v.reportArray.push(k);
            }
          });
        });
        this.allLabel = arrayUnique2(this.allLabel, "key");
        this.allLabel.forEach(v => {
          v.reportArray = arrayUnique2(v.reportArray, "configId");
        });
        // console.log("通过报表找到对应的报表类别", this.allLabel);
        if (this.isReportHome === 0) {
          this.reportLabel = [];
        }
        // this.reportLabel = reportList;

        this.reportLabel.push(...JSON.parse(JSON.stringify(reportList)));

        this.reportLabel = arrayUnique2(this.reportLabel, "configId");
        if (this.isReportHome === 0) {
          this.switchLabel(0, this.reportLabel[0]);
        }
      }
      this.$forceUpdate();
    },
    async queryEmployeePageListByEmployeeId() {
      const { result } = await this.$store.dispatch(
        "queryEmployeePageListByEmployeeId",
        {
          pageSize: 9999,
          pageNo: 1,
          employeeId: this.employeeId,
          layoutType: "miniprogram"
        }
      );
      const { records } = result;
      // console.log("所有已授权报表", records);
      if (records.length) {
        this.allReport = JSON.parse(JSON.stringify(this.options));
        this.allLabel = [];
        this.queryAllrep = records;
        this.allReport.forEach(v => {
          records.forEach(k => {
            if (v.key === k.sysCategoryId) {
              v.reportArray.push(k);
              let item = JSON.parse(JSON.stringify(v));
              item.reportArray = [];
              this.allLabel.push(item);
            }
          });
        });
      }

      this.allLabel = arrayUnique2(this.allLabel, "key");
      this.$forceUpdate();
      this.querySaveByEmployeeId();
      // this.addSsrAnalysisQueueByEmployeeId();
    },
    // async addSsrAnalysisQueueByEmployeeId(
    //   selectColumns,
    //   whereColumns,
    //   configId,
    //   groupColumns
    // ) {
    //   const { result } = await this.$store.dispatch(
    //     "addSsrAnalysisQueueByEmployeeId",
    //     {
    //       employeeId: this.employeeId,
    //       selectColumns,
    //       whereColumns,
    //       configId,
    //       groupColumns
    //     }
    //   );
    // },
    async getSysAllDictItems() {
      const { result } = await this.$store.dispatch("getSysAllDictItems", {
        employeeId: this.employeeId
      });
      this.sysAllDict = result;

      Vue.prototype.$sysAllDict = result;
      if (result) {
        this.queryStorePageListByEmployeeId().then(res => {
          this.keep.forEach(v => {
            if (v.reportName === "我的收藏") {
              v.previewComponents = res;
            }
          });
        });
        this.getTreeStruct();
      }
    },
    async queryStorePageListByEmployeeId() {
      const { result } = await this.$store.dispatch(
        "queryStorePageListByEmployeeId",
        {
          employeeId: this.employeeId,
          layoutType: "storeVisualReport"
        }
      );

      this.isReportHome = result.records.length;
      if (result.records && result.records.length) {
        this.reportHome = result.records[0];
        this.reportHome.reportName = "我的收藏";
        this.reportLabel = [this.reportHome];
        const list = result.records[0].layoutComponents;
        this.previewComponents = JSON.parse(list);
        this.previewComponents.forEach(v => {
          v.prop.isType = "phone";
          v.prop.reportName = "我的收藏";
          v.prop.employeeId = this.employeeId;
          if (v.component === "table-chart") {
            let groupColumns = [];
            v.prop.header.forEach(k => {
              if (k.isAggregateColumn !== "yes") {
                groupColumns.push(k);
              }
            });
          }
          if (v.prop.data && v.prop.data.length) {
            // v.chartData = this.initData(v, v.prop.data);
          }
        });
        return this.previewComponents;
      }
    },
    initData(v, data) {
      const keyMap = {};
      if (v.component === "pie-chart") {
        v.prop.groupValueList.map(v => {
          keyMap[v.columnName] = v.labelName;
        });

        v.prop.groupNameList.map(v => {
          keyMap[v.columnName] = v.labelName;
          if (v.associatedDictCode) {
            data.forEach(o => {
              o[v.associatedDictCode] =
                this.translation(v.associatedDictCode, o[v.columnName]) ||
                o[v.columnName];
            });
          }
        });

        let columns = [];
        for (let key in keyMap) {
          columns.push(keyMap[key]);
        }
        const rows = this.convertKey(data, keyMap);

        let chartData = {
          columns: columns.reverse(),
          rows
        };
        return chartData;
      } else if (v.component === "line-chart" || v.component === "bar-chart") {
        v.prop.xAxisData.map(v => {
          keyMap[v.columnName] = v.labelName;
          if (v.associatedDictCode) {
            data.forEach(o => {
              o[v.associatedDictCode] =
                this.translation(v.associatedDictCode, o[v.columnName]) ||
                o[v.columnName];
            });
          }
        });
        v.prop.yAxisData.map(v => {
          keyMap[v.columnName] = v.labelName;
          if (v.associatedDictCode) {
            data.forEach(o => {
              o[v.associatedDictCode] = this.translation(
                v.associatedDictCode,
                o[v.columnName]
              );
            });
          }
        });
        let columns = [];
        for (let key in keyMap) {
          columns.push(keyMap[key]);
        }
        const rows = this.convertKey(data, keyMap);

        let chartData = {
          columns: columns,
          rows
        };
        return chartData;
      } else if (v.component === "table-chart") {
        return data;
      }
    },
    convertKey(arr, keyMap) {
      let tempString = JSON.stringify(arr);
      for (var key in keyMap) {
        var reg = `/"${key}":/g`;
        tempString = tempString.replace(eval(reg), '"' + keyMap[key] + '":');
      }
      return JSON.parse(tempString);
    },
    translation(code, columnName) {
      if (columnName) {
        if (this.sysAllDict[code].find(o => o.value === columnName)) {
          return this.sysAllDict[code].find(o => o.value === columnName).text;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    remConfig() {
      // var devicePixelRatio = 1;
      // var scale = 1 / devicePixelRatio;
      // document.querySelector('meta[name="viewport"]').setAttribute('content','initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
      // 7.5根据设计稿的横向分辨率/100得来
      // alert(document.documentElement.clientWidth)
      var deviceWidth = document.documentElement.clientWidth;
      // var deviceWidth = window.screen.availWidth
      // alert(navigator.userAgent)
      // alert(deviceWidth)
      // console.log(navigator.userAgent)

      if (deviceWidth <= 360) {
        // deviceWidth = 750;
        // deviceWidth = 7.5 * 50;

        document.documentElement.style.fontSize = deviceWidth / 80 + "px";
        // console.log(document.documentElement.style.fontSize);
      }

      // 禁止双击放大
      document.documentElement.addEventListener(
        "touchstart",
        function(event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        false
      );
      var lastTouchEnd = 0;
      document.documentElement.addEventListener(
        "touchend",
        function(event) {
          var now = Date.now();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    // switchTab(index, item) {
    //   let startTime = "";
    //   let endTime = "";
    //   switch (item.value) {
    //     case "yesterday":
    //       startTime = moment().subtract(1, "days");
    //       endTime = startTime;
    //       break;
    //     case "today":
    //       startTime = moment();
    //       endTime = startTime;
    //       break;
    //   }
    //   this.startTime = startTime.format("YYYY-MM-DD") + " 00:00:00";
    //   this.endTime = endTime.format("YYYY-MM-DD") + " 23:59:59";
    //   this.activeTab = index;
    //   this.quertReports();
    // },
    onTip() {},
    checked() {
      // console.log("checked", val);
    },
    close() {
      this.showTip = false;
    },
    toUrl(index) {
      this.activeTab = index;
    },
    switchLabel(index, item) {
      this.activeLabel = index;
      const list = item.layoutComponents;
      this.previewComponents = JSON.parse(list);
      this.previewComponents.map(v => {
        v.prop.isType = "phone";
        // v.prop.reportName = v.prop.reportName;

        if (item.reportName !== "我的收藏") {
          v.prop.configId = item.configId;
        }
        v.prop.employeeId = this.employeeId;
        if (v.prop.data && v.prop.data.length) {
          // v.chartData = this.initData(v, v.prop.data);
        }
      });
    },

    async save() {
      let funcId = [];
      // if (this.reportLabel.length > 1) {
      //   let funcIdList = getSubtract(this.reportLabel, this.list, "configId");
      //   console.log("funcIdList", funcIdList);

      //   if (this.checkList.length) {
      //     this.funcIdList.push(...this.checkList);
      //   }

      //   this.funcIdList.forEach(v => {
      //     if (v.configId) {
      //       funcId.push(v.configId);
      //     }
      //   });
      // } else {
      //   this.checkList.forEach(v => {
      //     if (v.configId) {
      //       funcId.push(v.configId);
      //     }
      //   });

      //   console.log(funcId);
      // }
      if (this.checkList.length) {
        this.funcIdList.push(...this.checkList);
      }
      this.funcIdList.forEach(v => {
        if (v.configId) {
          funcId.push(v.configId);
        }
      });
      funcId = unique(funcId);
      let params = {
        funcType: "visualView",
        moduleType: "ssr",
        funcId: JSON.stringify(funcId),
        employeeId: this.employeeId
      };
      const { code } = await this.$store.dispatch("addByEmployeeId", params);
      if (code === "0") {
        this.getSysAllDictItems();
        this.drawer = false;
      }
      // this.$message({
      //   type: "success",
      //   message: "操作成功！"
      // });
      // this.$router.back(-1);
    }
  }
};
</script>
<style lang="scss">
.pagescroll {
  width: 100%;
}
.pagescroll .el-scrollbar__wrap {
  overflow-y: hidden;
}
.vx {
  background: #fafafa;
  // height: calc(100vh - 279px);
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    -webkit-box-shadow: -1px 0 0 0 #409eff;
    box-shadow: -1px 0 0 0 #409eff;
  }
  #vcharts {
    canvas {
      z-index: 1 !important;
    }
  }
}
.phone {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    z-index: 8999;
  }
}

.el-dialog__wrapper {
  z-index: 9999 !important;
}
.table-row {
  .el-checkbox__label {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.drawer-title {
  font-weight: bold;
  color: #2b2b2b;
}
.report-fixed {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  overflow: hidden;
}
.back-home {
  position: fixed;
  bottom: 95px;
  right: 20px;
  z-index: 9999;
  .home-button {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    box-sizing: border-box;
    padding: 0 5px;
    font-size: 14px;
  }
}
.preview-container {
  margin: 100px 0 66px 0;
  // .preview-body {
  //   div:last-child {
  //     margin-bottom: 110px;
  //   }
  // }
}
.preview-containers {
  margin: 60px 0;
  // width: 100%;
  .report-list {
    background: #ffffff;
    padding: 0 10px;
    border-bottom: 5px solid #f5f5f5;
    .report-category {
      padding: 10px 0;
    }
    .report-title {
      font-weight: bold;
      color: #2b2b2b;
      font-size: 15px;
      .icon-arrow-down {
        display: inline-block;
        font-size: 12px;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    .report-name {
      font-size: 15px;
      padding: 14px 0;
    }
  }
  .bb1 {
    border-bottom: 1px solid #eeeeee;
  }
}
.preview-list-group {
  // height: 603px;
  .preview-list-group-item {
    position: relative;
    box-sizing: border-box;
    cursor: move;
    border: 2px solid transparent;
    min-height: 20px;
    .widget {
      position: absolute;
      top: 0;
      right: -40px;
      width: 34px;
      cursor: pointer;
      .widget-label {
        display: inline-block;
        background-color: #fff;
        width: 80px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        pointer-events: none;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      }
      .widget-icon {
        display: none;
      }
      &::before {
        content: "";
        width: 0;
        height: 0;
        border-width: 5px;
        border-style: solid;
        border-color: transparent #fff transparent transparent;
        position: absolute;
        bottom: 7px;
        left: -10px;
      }
    }
    &:hover {
      .widget-icon {
        display: block;
        cursor: pointer;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        width: 40px;
        height: 28px;
        text-align: center;
        font-size: 16px;
        line-height: 28px;
        background: #fff;
        color: #e71370;
      }
      .widget-label {
        display: none;
        cursor: pointer;
      }
    }
    *:not(.widget-icon) {
      cursor: move !important;
    }
    &:last-child {
      margin-bottom: 50px;
    }
    &.active,
    &.active:hover {
      box-sizing: border-box;
      border: 2px solid #ea5798;
      cursor: move;
    }
    &:hover {
      box-sizing: border-box;
      border: 2px dashed #ea5798;
      cursor: move;
    }
  }

  .contact-us-item {
    position: absolute;
    bottom: 23px;
    width: 100%;
    z-index: 11;
    left: 0;
  }
  .list-group-item {
    transition: all 0.2s linear;
    background-color: #fddfeb !important;
    border-radius: 2px;
    color: #e2005d;
    text-align: center;
    .label {
      margin-top: 10px;
    }
  }
}

.picker-wrapper {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 30px;
  color: #999;
  .iconfont {
    color: #999;
  }
}
.headline {
  font-size: 17px;
}
.title {
  font-weight: bold;
}
.change-wrapper {
  background: #fff;
  padding: 15px;
  margin-bottom: 10px;

  .more {
    color: #999;
    font-size: 13px;
  }
  .menu {
    text-align: center;
    background: #fff;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .iconfont {
      font-size: 50rpx;
    }

    .text {
      margin-top: 10px;
    }
  }
}

.reports-header {
  > div {
    color: #666;
    padding-right: 20px;
  }
}
.reports-body {
  padding: 10px 0;

  > div {
    padding-right: 5px;
  }
}
.tabs {
  // padding: 30rpx 40rpx;
  background: #fff;

  .tab {
    position: relative;
    margin-right: 20px;

    &.active::after {
      position: absolute;
      bottom: -10px;
      left: 0;
      content: "";
      width: 100%;
      height: 3px;
      background: #005ceb;
    }
  }
}
.picker-depart {
  height: 50px;
  background: linear-gradient(
    -90deg,
    rgba(0, 92, 235, 1),
    rgba(63, 138, 255, 1)
  );
  padding: 5px 5px 0 5px;
  color: #fff;

  .store-picker {
    .store-name {
      width: 85px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 12px;

      .uni-input {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
}
.search-wrapper {
  padding: 8px 0;
  background: linear-gradient(
    -90deg,
    rgba(0, 92, 235, 1),
    rgba(63, 138, 255, 1)
  );
  white-space: nowrap;
  .label {
    box-sizing: border-box;
    display: inline-block;
    color: #fff;
    position: relative;
    height: 28px;
    line-height: 28px;
    margin: 0 20px;
    font-size: 15px;
    &.active::after {
      position: absolute;
      bottom: -2px;
      left: 0;
      content: "";
      width: 100%;
      height: 3px;
      background: #fff;
    }
  }
}
.reports-content {
  margin-top: 10px;
  padding-bottom: 15px;

  .line {
    width: 1px;
    height: 37px;
    background: #eee;
  }

  .titles {
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    text-align: center;
  }

  .text {
    font-size: 19px;
    font-weight: 500;
  }
}
.last-border {
  border-bottom: 1px solid #eee;
}
.in-headline {
  font-size: 16px;
  color: #ff7d4a;
  &::before {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 4px;
    content: "";
    background: #ff7d4a;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
.off-headline {
  font-size: 16px;
  color: #0096ff;
  &::before {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 4px;
    content: "";
    background: #0096ff;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
.header {
  position: fixed;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}
.tabbar-containers {
  position: fixed;
  margin: 0;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1004;
  height: 49px;
  &.inIphoneX {
    .tabbar {
      height: 69px;
      padding-bottom: 20px;
    }
  }
  div:nth-child(1) {
    border-right: 1px solid #eee;
  }
  .tabbar {
    box-sizing: border-box;
    list-style: none;
    background-color: #fff;
    box-shadow: 0 0 10px 0 hsla(0, 6%, 58%, 0.6);
    font-size: 14px;
    height: 49px;
    .iconfont {
      font-size: 19px;
    }

    .active {
      color: #005ceb;
    }

    .no-bg {
      height: 20px;
      width: 20px;
      margin: 0 auto;
      background: #f0f0f0;
    }
  }
}
.tabbar-container {
  position: fixed;
  margin: 0;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 66px;
  z-index: 1004;
  height: 49px;
  &.inIphoneX {
    .tabbar {
      height: 69px;
      padding-bottom: 20px;
    }
  }
  div:nth-child(1) {
    border-right: 1px solid #eee;
  }
  .tabbar {
    box-sizing: border-box;
    list-style: none;
    background-color: #fff;
    box-shadow: 0 0 10px 0 hsla(0, 6%, 58%, 0.6);
    font-size: 14px;
    height: 49px;
    .iconfont {
      font-size: 19px;
    }

    .active {
      color: #005ceb;
    }

    .no-bg {
      height: 20px;
      width: 20px;
      margin: 0 auto;
      background: #f0f0f0;
    }
  }
}
.tabbar-container-ipx {
  position: fixed;
  margin: 0;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 76px;
  z-index: 1004;
  height: 49px;
  &.inIphoneX {
    .tabbar {
      height: 69px;
      padding-bottom: 20px;
    }
  }
  div:nth-child(1) {
    border-right: 1px solid #eee;
  }
  .tabbar {
    box-sizing: border-box;
    list-style: none;
    background-color: #fff;
    box-shadow: 0 0 10px 0 hsla(0, 6%, 58%, 0.6);
    font-size: 14px;
    height: 49px;
    .iconfont {
      font-size: 19px;
    }

    .active {
      color: #005ceb;
    }

    .no-bg {
      height: 20px;
      width: 20px;
      margin: 0 auto;
      background: #f0f0f0;
    }
  }
}
.tip {
  background: #ffeee0;
  color: #ff7f10;
  font-size: 13px;
  // line-height: 12px;
}
.table-row {
  margin-left: 20px;
  height: 48px;
  border-bottom: 1px solid #eeeeee;
  .report-icon {
    width: 25px;
    height: 25px;
    background: #fff;
    border-radius: 18px;
  }
  .icon {
    .hmicon {
      font-size: 20px;
    }
  }
}
.report-footers {
  z-index: 100000;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-radius: 0 0 2px 2px;
  .report-save-btn {
    width: 200px;
    border-color: #005ceb;
    background: #005ceb;
    border-radius: 36px;
  }
}
.report-footer {
  z-index: 100000;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  border-radius: 0 0 2px 2px;
  .report-save-btn {
    width: 200px;
    height: 36px;
    font-size: 15px;
    border-color: #005ceb;
    background: #005ceb;
    border-radius: 36px;
  }
}

/*iphone 6,7,8plus screen-width:414px */

@media (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) {
  .report-mb {
    margin-bottom: 60px;
  }
}
/*iphone X screen-width:375px, screen-hight: 812px */

@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .report-mb {
    margin-bottom: 80px;
  }
}
/*iphone 5,5E screen-height:568px*/

@media (device-height: 568px) and (-webkit-min-device-pixel-ratio: 2) {
  .mb-count {
    margin-bottom: 50px;
  }
}
/*iphone 4  screen-width:320px*/

@media only screen and (min-width: 320px) and (max-width: 360px) {
}

/*三星Galaxy S5  screen-width:360px*/

@media only screen and (min-width: 360px) and (max-width: 414px) {
  .report-mb {
    margin-bottom: 200px;
  }
}

/*iphone 6  screen-width:375px*/

@media only screen and (min-width: 375px) and (max-width: 414px) {
}

/*iphone 6plus  screen-width:414px*/

@media only screen and (min-width: 414px) and (max-width: 768px) {
}

/*iPad Mini  screen-width:768px*/

@media only screen and (min-width: 768px) {
}

.img {
  width: 100%;
}

.income {
  img {
    width: 100%;
  }
}
</style>
